import { BaseEnum } from "./baseEnum"

const listEnum: Array<ExcusedAbsenceStatusType> = [];

export class ExcusedAbsenceStatusType extends BaseEnum {
  static Pending = new ExcusedAbsenceStatusType(0, 'PENDING', 'Pendente', 'warning');
  static Qualified = new ExcusedAbsenceStatusType(1, 'QUALIFIED', 'Qualificado', 'success');
  static Reproved = new ExcusedAbsenceStatusType(2, 'REPROVED', 'Reprovada', 'danger');

  constructor(public id: number, public value: string, public label: string, public className: string) {
    super(id, value, label, className)
    listEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listEnum;
  }
}